import Effects from 'effects/Effects.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import PhaseShiftAllpass from './PhaseShiftAllpass.js';
import PolyParameter from 'parameters/PolyParameter.js';

export default class FreakShifter extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Freak Shifter", () => new Tone.Gain(1), sequencerEngine);

        this.output = new Tone.Gain(1);

	this._sine = new Tone.Oscillator(0, "sine");
	this._cosine = new Tone.Oscillator(0, 'sine');
        this._cosine.phase = -90;

        this.frequencyParameter = new PolyParameter(
            'frequency', [this._sine.frequency, this._cosine.frequency],
            {
                defaultValue: 1,
                min: 1,
                max: 10000
            });
        this.registerParameter(this.frequencyParameter);

	this._sineMultiply = new Tone.Multiply(0);
	this._cosineMultiply = new Tone.Multiply(0);
	this._negate = new Tone.Negate();
	this._add = new Tone.Add();

	this._phaseShifter = new PhaseShiftAllpass(sequencerEngine);
	this.effectNode.connect(this._phaseShifter.effectNode);

	// connect the carrier frequency signal to the two oscillators
	// this.frequency.fan(this._sine.frequency, this._cosine.frequency);

	this._phaseShifter.offset90.connect(this._cosineMultiply);
	this._cosine.connect(this._cosineMultiply.input[1]);

	this._phaseShifter.connect(this._sineMultiply);
	this._sine.connect(this._sineMultiply.input[1]);
	this._sineMultiply.connect(this._negate);

	this._cosineMultiply.connect(this._add);
	this._negate.connect(this._add.input[1]);

	this._add.connect(this.output);

	// start the oscillators at the same time
	const now = Tone.Master.context.currentTime + 0.01;
	this._sine.start(now);
	this._cosine.start(now);
    }

    connect(x) {
        this.output.connect(x);
    }

    disconnect(x) {
        this.output.disconnect(x);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new FreakShifter(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }

    getJson() {
        let json = {
            ... super.getJson(),
            frequency: this.frequencyParameter.get(true),
        };

        json = this.saveParameterToJson(json, 'frequencyParameter', this.frequencyParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        bulkUpdate(this.frequencyParameter, json.frequency, bulk);

        bulk = {
            ... bulk,
            ... this.loadParameterFromJson(json, 'frequencyParameter', this.frequencyParameter, isCopy),
        };
        return bulk;
    }
}

